module.exports = __webpack_public_path__ + "img/renwu.765b9345.png";